/**
 * @name environment
 * @description This is the production environment
 */

const SERVER_URL = 'https://developer.yephome.com.au/';
const API_URL = 'https://api.yephome.com.au';
const API_DEVELOPER_URL = `${API_URL}/developer`;
const API_PUBLIC_URL = `${API_URL}/public`;
const API_AI_KEY = 'fc293b6d-8508-4781-926b-d326daa438a2';

export const environment = {
  name: 'prod',
  SERVER_URL,
  API_URL,
  API_DEVELOPER_URL,
  API_PUBLIC_URL,
  API_AI_KEY,
  VERIFICATION_CODE_URL: 'https://developer.yephome.com.au/customer/',
  GOOGLE_API_KEY: 'AIzaSyDzYyUjMxFvRFDsZcW_jaxMO7RQ47aNpP0',
  useHash: true,
  hmr: false,
  production: true,
  agentUrl: 'https://agent.yephome.com.au/agent-black',
  customerUrl: 'https://www.yephome.com.au/',
  devUrl: 'https://developer.yephome.com.au/black',
  bookDemoUrl: 'https://calendly.com/ken-vilaysane/30min',
  authCognito: true,
};
